export interface EnumEntry {
    value: string | number;
    translationKey: string;
}

export type EnumTranslationMap = EnumEntry[];

export const getEnumTranslationMap = (object: Record<string, string | number>): EnumTranslationMap =>
    Object.values(object).map(enumValue => ({ value: enumValue, translationKey: `app.enum.${enumValue}` }));
